export class Formatter {
	static designation(value: any): string {
		return value.designation;
	}

	static codeDesignation(value: any): string {
		return value.code + ' - ' + value.designation;
	}

	static none(value: any): string {
		return value;
	}
}
